export default '/payment/@status'
